// extracted by mini-css-extract-plugin
module.exports = {"logout":"googlestyles_logout__e5840"};